import { render, staticRenderFns } from "./LoyaltyPoints.vue?vue&type=template&id=ed7e3368&scoped=true&"
import script from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPoints.vue?vue&type=style&index=0&id=ed7e3368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7e3368",
  null
  
)

export default component.exports